<template>
  <!--eslint-disable-next-line sdui/require-focus-restore-on-disabled-button-->
  <b-button
    variant="link"
    :class="classes"
    :tabindex="canDoAction ? undefined : -1"
    :aria-hidden="canDoAction ? undefined : 'true'"
    :disabled="disabled"
    class="btn-round btn-action mb-4 btn btn-lg btn-block align-items-center"
    @click="trackAndNavigate"
  >
    <sdui-icon class="icon-add-o d-inline-block align-middle" />
    <slot />
    <span v-if="action.tag" class="tag">{{ action.tag }}</span>
  </b-button>
</template>

<script>
export default {
  name: 'MainMenuOption',
  props: {
    action: {
      type: Object,
      default: () => ({}),
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes() {
      return {
        'active-link': this.$me && this.action.isActive && this.canDoAction,
        'd-none': this.$me && !this.canDoAction, // hide option if user isnt permitted
        'd-flex': this.$me && this.canDoAction,
      }
    },

    canDoAction() {
      // if property permObject exists but its null -> not permitted - this way we prevent console errors by evaluating $can on empty objects
      if (Object.prototype.hasOwnProperty.call(this.action, 'permObject') && !this.action.permObject) return false
      if (Array.isArray(this.action.can)) return this.action.can.every((can) => this.$can(can, this.action.permObject || this.$me))
      return this.$can(this.action.can, this.action.permObject || this.$me)
    },
  },

  methods: {
    trackAndNavigate() {
      if (this.action.track) this.action.track()

      if (this.action.customEvent?.name) return this.$emit(this.action.customEvent.name)
      this.$router.push({ name: this.action.routeName, params: this.action.params })
    },
  },
}
</script>

<style scoped lang="scss">
.icon {
  padding: 0 7px;
}

.btn-round {
  &.active-link {
    color: $color-primary;
  }
  &.disabled {
    pointer-events: none;
    user-select: none;
    color: $color-gray-400 !important;
  }
}

.tag {
  font-size: pxtorem(11);
  color: $color-white;
  padding: 2px 8px;
  border-radius: 30px;
  margin-left: 5px;
  background: $color-gray-300;
}

.icon-add-o::before {
  line-height: pxtorem(24) !important;
}
</style>
